import './shared';

import { mountReactComponent } from './react/mount';

mountReactComponent('#map-agencies', () =>
  import(/* webpackChunkName: "agencies-map" */ './components/Map')
);
